// extracted by mini-css-extract-plugin
export var active = "footer-module--active--086b9";
export var annualEvents = "footer-module--annual-events--ddd30";
export var annualNews = "footer-module--annual-news--9d3e0";
export var annualProjects = "footer-module--annual-projects--1ee54";
export var backgroundImage = "footer-module--background-image--7a783";
export var btnClose = "footer-module--btn-close--e9455";
export var btnOutlineLsuGold = "footer-module--btn-outline-lsu-gold--f9804";
export var btnOutlineLsuPurple = "footer-module--btn-outline-lsu-purple--a54f4";
export var btnPrimary = "footer-module--btn-primary--f3b10";
export var btnSecondary = "footer-module--btn-secondary--29b6b";
export var eventBlog = "footer-module--event-blog--3364b";
export var finePrint = "footer-module--fine-print--b20c8";
export var footer = "footer-module--footer--87592";
export var formControl = "footer-module--form-control--c9850";
export var gray800 = "footer-module--gray-800--466bd";
export var h1 = "footer-module--h1--2726b";
export var h2 = "footer-module--h2--59e34";
export var h3 = "footer-module--h3--8c3b6";
export var h4 = "footer-module--h4--d350f";
export var h5 = "footer-module--h5--0c42f";
export var h6 = "footer-module--h6--6b54e";
export var headingLight = "footer-module--heading-light--79e5a";
export var hover = "footer-module--hover--64f0d";
export var icon = "footer-module--icon--7a5e7";
export var iconDmaelogo = "footer-module--icon-dmaelogo--3e6f2";
export var iconLsu = "footer-module--icon-lsu--0c16d";
export var inputGroup = "footer-module--input-group--55026";
export var menu = "footer-module--menu--57006";
export var navLink = "footer-module--nav-link--1e2ba";
export var navbarDark = "footer-module--navbar-dark--02350";
export var navbarNav = "footer-module--navbar-nav--90751";
export var navbarToggler = "footer-module--navbar-toggler--38424";
export var navbarTogglerIcon = "footer-module--navbar-toggler-icon--ed2c7";
export var newsArticle = "footer-module--news-article--89f01";
export var newsEventsEvents = "footer-module--news-events-events--c3a48";
export var newsEventsNews = "footer-module--news-events-news--08dc5";
export var pageItem = "footer-module--page-item--60039";
export var pageLink = "footer-module--page-link--f14ec";
export var projectPost = "footer-module--project-post--39281";
export var smallSpace = "footer-module--small-space--f096c";
export var textLight = "footer-module--text-light--fcdd8";
export var textLsuLightGold = "footer-module--text-lsu-light-gold--12991";
export var textWhite = "footer-module--text-white--2800a";
export var topNavigation = "footer-module--top-navigation--8fb39";
export var underline = "footer-module--underline--5aec4";